import tw from "twin.macro";

export const H1Heading = tw.h1`text-4xl sm:text-5xl font-black tracking-wide text-center`
export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`
export const Subheading = tw.h5`font-bold text-primary-500`

